import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './Components/FormattingComponents/Navbar';
import Home from './Components/PageComponents/Home';
import Contact from './Components/PageComponents/Contact';
import Services from './Components/PageComponents/Services';
import HowWeWork from './Components/PageComponents/HowWeWork';
import TermsOfService from './Components/PageComponents/TermsOfService';
import PrivacyPolicy from './Components/PageComponents/PrivacyPolicy';
import './App.css';
import Rive from '@rive-app/react-canvas';
import { useEffect, useMemo, useRef } from 'react';

function App() {
  const circleElement = document.querySelector('.clipPath-circle');
  const appElement = useRef(null);
  const routeColour = useMemo(() => {
    return {
      '/': 'white-bg-2',
      '/services': 'orange-bg',
      '/how-we-work': 'blue-bg',
      '/contact': 'white-bg-2',
      '/terms-of-service': 'white-bg-2',
      '/privacy-policy': 'white-bg-2'
    };
  }, []);
  const location = useLocation();
  useEffect(() => {
    console.log(routeColour[location.pathname]);
    if (circleElement) {
      circleElement.className = `clipPath-circle ${routeColour[location.pathname]} active`;
      setTimeout(() => {
      circleElement.classList.remove('active');
    }, 1200);
    }
    if (appElement) {
      appElement.current.className = `background-overlay ${routeColour[location.pathname]}`;
    }
    
  }, [location, appElement, circleElement, routeColour]);

  return (
    <div className="App">
      <div ref={appElement} className="background-overlay">
        <div className="clipPath-circle"></div>
        <Navbar />
        <div style={{ paddingTop: '100px' }}></div>
        <Routes>
          <Route path='/' element={<Home />}></Route>
          <Route path='/services' element={<Services />}></Route>
          <Route path='/how-we-work' element={<HowWeWork />}></Route>
          <Route path='/contact' element={<Contact />}></Route>
          <Route path='/terms-of-service' element={<TermsOfService />}></Route>
          <Route path='/privacy-policy' element={<PrivacyPolicy />}></Route>
        </Routes>

        <div className="consultation">

          <div className="animation-container">
            <Rive
              src="animations/maple.riv"
              stateMachines="State Machine 1"
              autoplay={true}
              style={{ width: 150, height: 150 }}
            />
          </div>
          <a href="https://calendly.com/abdullahyousuf225/30min" target="_blank" rel="noreferrer" className="consultation-button white-text hind-mysuru-bold">Book a Free Consultation</a>
        </div>
        <div className='mt-5'></div>
        <footer class="text-center text-lg-start bg-body-tertiary text-muted">
          <section class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
            <div class="me-5 d-none d-lg-block">
              <span>Get connected with us on social networks:</span>
            </div>
            <div>
              <a href="https://www.facebook.com/people/Maplemark-Media/61560179055036/" target="_blank" rel="noreferrer" class="me-4 text-reset">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a href="https://x.com/MapleMarkMedia" target="_blank" rel="noreferrer" class="me-4 text-reset">
                <i class="fab fa-x-twitter"></i>
              </a>
              <a href="https://www.youtube.com/channel/UC8ZegkVW9wj_1logTFKWERw" target="_blank" rel="noreferrer" class="me-4 text-reset">
                <i class="fab fa-youtube"></i>
              </a>
              <a href="https://www.instagram.com/maplemarkmedia/" target="_blank" rel="noreferrer" class="me-4 text-reset">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="https://ca.linkedin.com/company/maplemark-media" target="_blank" rel="noreferrer" class="me-4 text-reset">
                <i class="fab fa-linkedin"></i>
              </a>
            </div>
          </section>
          <section class="">
            <div class="container text-center text-md-start mt-5">
              <div class="row mt-3">
                <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                  <h6 class="text-uppercase fw-bold mb-4">
                    <div className="row align-middle">
                      <img src="images/MMM-Logo.png" alt='MapleMark Media Logo' style={{ width: '50px', height: 'auto' }}></img>MapleMark Media
                    </div>

                  </h6>
                </div>
                <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                  <h6 class="text-uppercase fw-bold mb-4">
                    Useful links
                  </h6>
                  <p>
                    <a href="/services" class="text-reset">Services</a>
                  </p>
                  <p>
                    <a href="/how-we-work" class="text-reset">How We Work</a>
                  </p>
                  <p>
                    <a href="/contact" class="text-reset">Contact</a>
                  </p>
                </div>

              </div>
            </div>
          </section>

          <div class="text-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
            Copyright © MapleMark Media Inc. 2025 &bull; All rights reserved. &bull; <a href="/terms-of-service" class="text-reset">Terms of Service</a> &bull; <a href="/privacy-policy" class="text-reset">Privacy Policy</a>
          </div>

        </footer>
      </div>

    </div>
  );
}

export default App;
